import React, { useState } from 'react';
import {
  Box, Tabs, Tab, Typography, Grid, Container,
} from '@mui/material';
import Typography500 from 'views/common/components/UI/Typography500';
import { useTranslation } from 'next-i18next';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
import PATHS from 'lib/navigation/paths';
import { ImgBox } from 'views/common/components';
import StyledBox from 'views/information-module/AffiliateProgramView/common/components/AffiliateProgramDetails/AffiliateProgramDetails.styles';

const AffiliateProgramDetails = () => {
  const [tabValue, setTabValue] = useState(0);
  const { t } = useTranslation('fe_er_affiliate_program_page');
  const appNavigator = useAppNavigator();
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    if (newValue === 1) {
      appNavigator.push(PATHS.hotelpartners());
    }
  };
  const imagesList = [
    {
      id: 1,
      src: '/imgs/AFFILIATE1.png',
    },
    {
      id: 2,
      src: '/imgs/AFFILIATE2.png',
    },
    {
      id: 3,
      src: '/imgs/AFFILIATE3.png',
    },
  ];
  const detialsList = [
    // {
    //   id: 1,
    //   title: t('fe_er_affiliate_program_page:ota_integration_header'),
    //   desc: t('fe_er_affiliate_program_page:ota_integration_text'),
    // },
    {
      id: 1,
      title: t('fe_er_affiliate_program_page:white_label_header'),
      desc: t('fe_er_affiliate_program_page:white_label_text'),
    },
    {
      id: 1,
      title: t('fe_er_affiliate_program_page:benefits_header'),
      desc: t('fe_er_affiliate_program_page:benefits_text'),
    },
  ];

  return (
    <StyledBox>
      <Box className="APDTabsContiner">
        <Container maxWidth="xl">
          <Tabs value={tabValue} onChange={handleTabChange} className="APDTabs">
            <Tab label={t('fe_er_affiliate_program_page:Affiliate_partners')} />
            <Tab label={t('fe_er_affiliate_program_page:hotel_partners')} />
          </Tabs>
        </Container>
      </Box>
      <Container maxWidth="xl" className="APDContainer">
        <Grid container>
          <Grid item lg={6} md={12} xs={12}>
            <Box className="APDTextSection ">
              <Typography
                className="APDDescText secoundryMainColor"
                variant="body2"
                dangerouslySetInnerHTML={{
                  __html: t('fe_er_affiliate_program_page:introduction'),
                }}
                component="p"
              />
              {detialsList.map((item) => (
                <Box key={item.id}>
                  <Typography500
                    variant="h3"
                    component="p"
                    className="APDTHeaderText secondaryMainColor">
                    {item.title}
                  </Typography500>
                  <Typography
                    className="APDDescText secondaryMainColor"
                    variant="body2"
                    dangerouslySetInnerHTML={{
                      __html: item.desc,
                    }}
                    component="p"
                  />
                </Box>
              ))}
            </Box>
          </Grid>
          <Grid
            item
            lg={6}
            md={12}
            xs={12}
            className="showDESKTOP APDImagesContiner">
            {imagesList.map((item) => (
              <Box key={item.id} mb={3}>
                <ImgBox
                  image={{ src: `${item.src}`, alt: 'BikeImage' }}
                  imgWidth="444px"
                  imgHeight="296px"
                  unoptimized={false}
                />
              </Box>
            ))}
          </Grid>
        </Grid>
      </Container>
    </StyledBox>
  );
};

export { AffiliateProgramDetails };
